import { Group, Paper, Text } from '@mantine/core';
import { TeammateAvatar } from '@/components/TeamAvatar';
import { ReactElement } from 'react';
import { DateTimeTooltip } from './DateTimeTooltip';
import { TaskCompletedTimelineGroup } from '../types';

/**
 * Lightweight "Task completed: [title]" timeline row (Close-style). The
 * Mustard checkbox marker lives in the timeline gutter (TimelineItemWithIcon)
 * like every other card; the header matches the Notes card's type scale.
 * Derived from the task's status — an Undo reopens the task and the row
 * disappears with the next refresh.
 */
export function TaskCompletedTimelineItem({ group }: { group: TaskCompletedTimelineGroup }): ReactElement | null {
  const item = group.items[0];
  if (!item) {
    return null;
  }

  return (
    <Paper withBorder radius="md" p="sm" style={{ flex: 1 }}>
      <Group justify="space-between" wrap="nowrap" gap="sm">
        <Text style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
          <Text component="span" fw={600} pr="xs">
            Task completed:
          </Text>
          {item.title}
        </Text>
        <Group gap="xs" wrap="nowrap" style={{ flexShrink: 0 }}>
          {item.completedBy && <TeammateAvatar practitioner={item.completedBy} size={22} />}
          <DateTimeTooltip date={item.timestamp} />
        </Group>
      </Group>
    </Paper>
  );
}
